import React from "react";
import styled from "@emotion/styled";
import { PatientDocumentPOCItem } from "../../messages/PatientDocuments";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";

interface POCItemHeaderProps {
  item: PatientDocumentPOCItem;
  index: number;
  isChecked: boolean;
  isRequired: boolean;
  readonly: boolean;
  onTaskCheck: (index: number) => void;
}

export function POCItemHeader({
  item,
  index,
  isChecked,
  isRequired,
  readonly,
  onTaskCheck,
}: POCItemHeaderProps) {
  return (
    <HeaderContainer>
      <HeaderTitle>{item.name}</HeaderTitle>
      <HeaderRequired>
        <div className="checkbox">
          <input
            type="checkbox"
            className="checkbox__input"
            checked={isChecked}
            onChange={() => onTaskCheck(index)}
            disabled={readonly}
          />
          <span className="checkbox__checkmark" />
        </div>
        <label>{isRequired ? translate(STRINGS.REQUIRED) : ""}</label>
      </HeaderRequired>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
`;

const HeaderTitle = styled.span`
  margin-right: 10px;
`;

const HeaderRequired = styled.div`
  flex-shrink: 0;
  font-weight: normal;

  > label {
    text-transform: capitalize;
  }

  > .checkbox {
    margin-right: 8px;
  }
`;
